import { ReactNode } from "react"
import { EVendorType } from "./api-keys/vendors"

export type OptionItem = {
  value: string
  label: ReactNode
  isDisabled?: boolean
}

export type EventOptionItem = {
  value: string | undefined
  label: ReactNode
}

export enum ESortOrder {
  Desc = "desc",
  Asc = "asc",
}
export enum EStatus {
  Active = "active",
  Disabled = "disabled",
  Hidden = "hidden",
  Disapproved = "disapproved",
  Inactive = "inactive",
  Suspended = "suspended",
  Yes = "yes",
  No = "no",
  Pending = "pending",
}
export type InputTagItem = {
  id: string
  className: string
  [key: string]: unknown
}

export type UploadItem = {
  id: string
  url: string
  file?: File
  position?: number | string
  size?: number
  fileName?: string
  href?: string
}

export type ValidUploadItem = {
  id: string
  url: string
  file: File
  position?: number | string
  size?: number
  fileName?: string
  href?: string
}

export enum EAction {
  Add = "add",
  Create = "create",
  Edit = "edit",
  Update = "update",
  Detail = "detail",
}

export type CommonVendorParams = {
  limit?: number
  offset?: number
  vendorId?: string
  q?: string
  status?: any
}

export enum EErpStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  SLOW_MOVING = "slow-moving",
  NEW = "new",
  SPECIAL_TO_ORDER = "special-to-order",
  SHORT_EXPIRY = "short-expiry",
  DISCONTINUED_BY_PRINCIPAL = "discontinued-by-principal",
  DISCONTINUED = "discontinued",
  OUT_OF_STOCK_PRINCIPAL = "out-of-stock-principal",
}

export enum EForensicGroup {
  MEDICAL_DEVICE = "MD",
  PRESCRIPTION_ONLY_MEDICINE = "POM",
  PERSONAL = "PERSONAL",
  GENERAL_SALE_LIST = "GSL",
  PHARMACY_ONLY_MEDICINE = "P",
  HEALTH_SUPPLEMENT = "HS",
  FOOD = "FOOD",
  CONTROLLED_DRUGS = "CD",
}

export enum EProductStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
  HIDDEN = "hidden",
  DISAPPROVED = "disapproved",
}

export type PaginationMetadata = {
  totalPage: number
  limit: number
  page: number
  count: number
  offset: number
}

export enum EUserRole {
  Vendor_Super_Admin = "vendor_super_admin",
  Pom_Super_Admin = "pom_super_admin",
  Vendor_Admin = "vendor_admin",
}

export const UserRoleLabels = {
  [EUserRole.Vendor_Super_Admin]: "Vendor super admin",
  [EUserRole.Pom_Super_Admin]: "Pom super admin",
  [EUserRole.Vendor_Admin]: "Vendor admin",
}

export type UserInfo = {
  email: string
  id: string
  name: string
  role: EUserRole
  vendor_id?: string
  vendor?: VendorInfo
  impersonated?: boolean
}

export type VendorInfo = {
  id: string
  handle: string
  name: string
  brn: string
  email: string
  contact_number: string
  address: string
  website: string
  featured_vendor: boolean
  managed_vendor: string
  managing_vendor: string
  gst_registered: boolean
  subdomain_name: string
  short_description: string
  profile_logo: string | null
  invoice_logo: string | null
  background_main: string | null
  term_and_conditions: string | null
  setting: {
    borderWidth: string | null
    borderStyle: string | null
    borderColor: string | null
    boxShadow: string | null
  }
  status: EStatus | null
  registration_date: string | number | Date | null
  application_date: string | number | Date | null
  position: any | null
  created_at: string | number | Date | null
  updated_at: string | number | Date | null
  deleted_at: string | number | Date | null
  moq?: number
  shipping_method?: string
  shipping_moq?: number
  vendor_type?: EVendorType
  parent_vendor?: {
    id: string
    name?: string
  }
}
